import React from "react";
import PropTypes from "prop-types";
import TopNav from "./TopNav";
import SimpleTopNav from "./SimpleTopNav";
import { DomainScopes } from "../../constants/DomainConstants";
import Row from "../common/Row";
import RelativeLink from '../common/RelativeLink';

const PageHeader = ({ title, intro, showTopNav, showSimpleTopNav, disableSimpleTopNav, topNavTabSettings, scope, accountId, accountType }) => {
	const titleItem = title ? <h1 className="c-page-header__title">{title > 100 ? title.substring(0, 10) : title}</h1> : null;
	const introItem = intro ? scope === DomainScopes.DEFAULT ? <Row>{intro}</Row> : <p className="c-page-header__text">{intro}</p> : null;
	const topNavItem = showTopNav ?
		showSimpleTopNav ?
			<SimpleTopNav disabled={disableSimpleTopNav} />
			: <TopNav topNavTabSettings={topNavTabSettings} scope={scope} accountId={accountId} accountType={accountType} />
		: null;

	return (

		<header className="c-header js-header ">
			<div className="l-container:12/12 l-container--with-default-spacing c-header__container">
				<div className="c-logo c-header__logo">
					<RelativeLink to={'/sporteroverzicht'} className="c-logo__link ">
						<span className="c-logo__nado">Nado.</span>
						<span className="c-logo__vlaanderen">Vlaanderen</span>
					</RelativeLink>
				</div>
				{topNavItem}
			</div>
		</header>
	);
};

PageHeader.propTypes = {
	title: PropTypes.string,
	intro: PropTypes.string,
	showTopNav: PropTypes.bool.isRequired,
	showSimpleTopNav: PropTypes.bool.isRequired,
	disableSimpleTopNav: PropTypes.bool.isRequired,
	topNavTabSettings: PropTypes.object.isRequired,
	scope: PropTypes.string,
	accountId: PropTypes.string,
	accountType: PropTypes.string
};

export default PageHeader;
